/**
 * テナント(APIキー生成用)
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/tenant_api`

const tenant_api = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @param _commit
     * @return {Promise<unknown>}
     */
    show ({ _commit }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default tenant_api

